// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--3fSzh","title":"layout-module--title--HQ8vs"};